import React, { useRef } from 'react';

const withCreatedRefHOCGenerator = (Component) => {
  function WithCreatedRefHOC(props) {
    const createdRef = useRef();
    return <Component {...props} createdRef={createdRef} />;
  }

  return WithCreatedRefHOC;
};

const withCreatedRef = () => (Component) => withCreatedRefHOCGenerator(Component);

export default withCreatedRef;
